import React, { useState } from 'react'
import {
    Container,
    Content,
    Form,
    Alert,
    Button
} from './styles';
import { useAuth } from '../../contexts/AuthContexts';
import { Link, useNavigate } from 'react-router-dom';

export const SignUp = () => {

    const [registerEmail, setRegisterEmail] = useState("")
    const [registerName, setRegisterName] = useState("")
    const [registerPassword, setRegisterPassword] = useState("")
    const [registerPasswordConfirmation, setRegisterPasswordConfirmation] = useState("")
    const { signup } = useAuth();
    const [ error, setError ] = useState("");
    const [ loading, setLoading ] = useState(false);
    const history = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(registerPassword !== registerPasswordConfirmation){
            return setError("Senhas não correspondentes");
        }

        try {
            setError("");
            setLoading(true);
            await signup(registerName, registerEmail, registerPassword);
            history("/profile");
        } catch {
            setError("Failed to create account");
        }

        setLoading(false);
    }
    return (
        <Container>
            <Content>
                <Form>
                    <span>olá,</span>
                    <h1>Cadastre-se</h1>
                    { error && <Alert>{error}</Alert>}
                    <input
                        className="input"  
                        placeholder="Name"
                        onChange = {(event) => {
                            setRegisterName(event.target.value)
                        }}
                    />
                    <input
                        className="input"  
                        placeholder="Email"
                        onChange = {(event) => {
                            setRegisterEmail(event.target.value)
                        }}
                    />
                    <input
                        className="input"  
                        type="password"
                        placeholder="Senha"
                        onChange = {(event) => {
                            setRegisterPassword(event.target.value)
                        }}
                    />
                    <input
                        className="input"  
                        type="password"
                        placeholder="Confirme sua Senha"
                        onChange = {(event) => {
                            setRegisterPasswordConfirmation(event.target.value)
                        }}
                    />
                    <Button disabled={ loading } onClick={ handleSubmit }> Criar conta </Button>
                </Form>
                <div>
                    Já tem uma conta? <Link to="/login">Login</Link>
                </div>
            </Content>
        </Container>
    )
}